<!--
SkeletonTableComponent — <app-skeleton-table>
Rendu conditionnel : si headers est null → pas de <thead>.
La barre de progression est placée dans une <tr> dédiée sous le header
(identique à la convention déjà utilisée dans user-list).
-->
<table [class]="tableClass">

  <!-- ── Header (optionnel) ──────────────────────────────────────────────── -->
  @if (headers !== null) {
    <thead>
      <tr>
        @for (col of resolvedColumns; track col; let i = $index) {
          <th
            [ngStyle]="getThStyle(col)">
            {{ headers && headers[i] ? headers[i] : '' }}
          </th>
        }
      </tr>
      <!-- Barre de progression animée -->
      @if (showProgressBar) {
        <tr class="table-loading-row">
          <td [attr.colspan]="resolvedColumns.length">
            <div class="table-progress-bar">
              <div class="table-progress-bar-inner"></div>
            </div>
          </td>
        </tr>
      }
    </thead>
  }

  <!-- ── Corps — lignes skeleton ────────────────────────────────────────── -->
  <tbody>
    @for (i of rowIndexes; track i) {
      <tr [class]="rowClass">
        @for (col of resolvedColumns; track col) {
          <td
            [ngStyle]="getTdStyle(col)">
            <span
              class="skeleton"
              [ngStyle]="getCellStyle(col)">
            </span>
          </td>
        }
      </tr>
    }
  </tbody>

</table>